import { useRef, useEffect, useState } from "react";
import baterry_mountain from "../../../assets/baterry_mountain.png";
import '../AlphaEss.css';
import { Link } from 'react-router-dom';

const productName = "Alpha ESS";

export default function ProductHero() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => setInView(e.isIntersecting), { threshold: 0.2 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className={`alpha-proven-brands-section ${inView ? "alpha-hero-in-view" : ""}`}>
      <div className="alpha-brands-content">
        <div className="alpha-brands-image-container">
          <img
            src={baterry_mountain}
            alt="Modern home with solar battery system"
            className="alpha-brands-image"
          />
        </div>
        <div className="alpha-brands-info-card">
          <h1>{productName}</h1>
          <h2>Home Solar Battery Systems</h2>
          <p className="alpha-info-footer-list">
            The {productName} is a flexible, all-in-one solar and battery solution designed for modern Australian homes.
          </p>
          <div className="free_quote_div">
            <Link to="/contact" className="free_quote_btn">
              Get Free Quote
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
